import React, { useEffect } from "react";
import {
  useMotionTemplate,
  useMotionValue,
  motion,
  animate,
} from "framer-motion";

const COLORS_TOP = ["#7C3AED", "#3B82F6", "#6366F1", "#8B5CF6"];

const AuroraHero = ({ children }) => {
  const color = useMotionValue(COLORS_TOP[0]);

  useEffect(() => {
    animate(color, COLORS_TOP, {
      ease: "easeInOut",
      duration: 10,
      repeat: Infinity,
      repeatType: "mirror",
    });
  }, [color]);

  const backgroundImage = useMotionTemplate`radial-gradient(125% 125% at 50% 0%, #020617 40%, ${color})`;

  return (
    <motion.section
      style={{
        backgroundImage,
      }}
      className="aurora-hero relative overflow-hidden bg-gray-950 text-gray-200 w-full min-h-screen"
    >
      <div className="relative z-10 w-full h-full">{children}</div>
    </motion.section>
  );
};

export default AuroraHero;
